module.exports = __webpack_public_path__ + "img/deco-paper-left.4b21bb6.png";